<router-outlet></router-outlet>

<div *ngIf="debug">
    <div *ngFor='let msg of log.msgs'>
        <hr/>
        {{msg}}
    </div>
</div>